import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import TourbuzzHeader from "~/components/TourbuzzHeader";
import TourbuzzFooter from "~/components/TourbuzzFooter";
import LoggedInUserWrapper from "~/components/wrapper/LoggedInUserWrapper";
import CustomBrandingStyle from "~/components/CustomBrandingStyle";

const App = props => {
  const { children } = props;
  return (
    <LoggedInUserWrapper>
      {(user, userStore) => (
        <>
          <CustomBrandingStyle />
          <TourbuzzHeader user={user} />
          <div id="main">{children(user, userStore)}</div>
          <TourbuzzFooter user={user} />
        </>
      )}
    </LoggedInUserWrapper>
  );
};

App.propTypes = {
  children: PropTypes.func.isRequired,
};

export default observer(App);
